import { useErrorContext } from '../error/ErrorBoundaryContext';
import { useCallback, useState } from 'react';
import { ErrorName } from '../error/errors';

export default function usePromiseWithErrorHandling<
  Arguments extends any[],
  Return,
>(
  asyncFn: (...args: Arguments) => Promise<Return>,
  expectedErrors: ErrorName[] = []
): {
  value: Return | undefined | null;
  run: (...args: Arguments) => void;
} {
  const [value, setValue] = useState<Return | null>();
  const { notifyErrorFromComponent } = useErrorContext();

  const run = useCallback(
    (...args: Arguments) => {
      asyncFn(...args)
        .then(value => setValue(value))
        .catch(error => {
          const isErrorExpected =
            error instanceof Error &&
            expectedErrors.includes(error.name as ErrorName);

          if (!isErrorExpected) {
            notifyErrorFromComponent(error);
          }

          setValue(null);
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [notifyErrorFromComponent]
  );

  return { value, run };
}
